export const SET_WORKOUT_TEMPLATES = 'SET_WORKOUT_TEMPLATES';
export const SET_WORKOUT_TEMPLATE_BY_ID = 'SET_WORKOUT_TEMPLATE_BY_ID';
export const RESET_WORKOUT_TEMPLATE_BY_ID = 'RESET_WORKOUT_TEMPLATE_BY_ID';
